import { FC } from 'react';

import { startCase } from 'lodash';

import { Heading, Icon, IconSvg, Link, Rating } from '@/components';
import { useFeaturedFlag } from '@/hooks';
import { GProduct } from '@/types';
import { CompoundType } from '../Product/context/ProductContext';
interface IProductFeatsProps {
  product: GProduct & { category_url: string };
  compoundList: CompoundType[];
}

const ProductFeats: FC<IProductFeatsProps> = ({ product, compoundList }) => {
  const { disableProductReviews } = useFeaturedFlag();

  return (
    <div className={'details__feats'}>
      <Heading className={'details__category_title'} level={3}>
        <Link
          aria-label={`Go to ${product?.category}`}
          className="details__link"
          href={product.category_url}
        >
          {startCase(product.category as string)}
        </Link>
      </Heading>
      {!disableProductReviews && (
        <div className={'acceptance__level'}>
          <Rating
            className={'rating__card'}
            value={product.review_rating || 0}
          />
          <span className={'reviews'}>{`(${
            product?.reviews || 0
          } reviews)`}</span>
        </div>
      )}
      {compoundList?.length > 0 || product?.dosage ? (
        <>
          <Heading className={'details__h3'} level={3}>
            Details
          </Heading>
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
            }}
          >
            {compoundList?.map(({ type, value }) => {
              if (!value) return null;

              const icon = type === 'THC' ? 'vector' : 'water_drop_black';
              return (
                <div className={'content__flex'} key={type}>
                  {type === 'THC' || type === 'CBD' ? (
                    <Icon className={'icon'} name={icon} />
                  ) : (
                    <IconSvg name={type?.toLowerCase()} />
                  )}
                  <p className={'description'}>
                    {type} <span className={'highlighted'}>{value}</span>
                  </p>
                </div>
              );
            })}
            {/*  {product?.dosage ? (
              <div className={'content__flex'}>
                <Icon className={'icon'} name="water_drop_black" />
                <p className={'description'}>
                  <span className={'highlighted'}>{product?.dosage} </span>
                  {product?.amount || ''}
                </p>
              </div>
            ) : null} */}
          </div>
          <small>
            *This % may represent an aggregate of THC/CBD, THCa/CBDa, THCb/CBDb
            within the product. Consumers should review the actual product label
            for exact % of THC/CBD.
          </small>
        </>
      ) : null}
    </div>
  );
};

export { ProductFeats };
